import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function StorefrontLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FFF9F2] rangoli-bg">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
